import { Icon } from '../index';
import './checkbox.scss';

const Checkbox = ({
	id,
	name,
	title,
	checked,
	disabled = false,
	value,
	linkCheckbox,
	buttonCheckbox,
	clazz,
	border = true,
	flag,
	onChange,
	onClick,
	subTitle = '',
	readOnly,
	icon,
	iconSize = '',
	iconClazz,
	radio,
	onKeyUp,
	children,
	important,
	textClazz,
	tabIndex,
	link,
}) => {
	const handleClick = (e) => {
		e.stopPropagation();

		const input =
			e.currentTarget.querySelector('input[type="checkbox"]') || e.target;
		if (input) input.blur();

		if (onClick) {
			onClick(e);
		}
	};

	const handleChange = (event) => {
		if (onChange) {
			onChange(event);
		}
	};

	const handleKeyUp = (event) => {
		if (event.key === 'Enter') {
			event.preventDefault();
			event.stopPropagation();
			handleChange(event);
		}
	};

	let defaultCheckboxProps = {
		type: 'checkbox',
		tabIndex: tabIndex,
		disabled: disabled,
		id: id,
		name: name,
		onChange: handleChange,
		onKeyUp: handleKeyUp,
		onClick: disabled ? null : handleClick,
		checked: checked,
		value: value,
		readOnly: readOnly,
	};

	if (linkCheckbox) {
		return (
			<a
				className={`checkbox-button link-checkbox${checked ? ' checkbox_checked' : ''}${disabled ? ' checkbox_disabled' : ''}`}
				tabIndex={disabled ? null : 0}
				onClick={disabled ? null : onClick}
				onKeyUp={onKeyUp}
				href={linkCheckbox}
			>
				{/* <input {...defaultCheckboxProps} /> */}
				<label htmlFor={id}>
					{textClazz ? (
						<span className={textClazz}>{title}</span>
					) : (
						title
					)}
					{children}
				</label>
			</a>
		);
	}

	if (buttonCheckbox) {
		return (
			<label
				className={`checkbox-button${disabled ? ' checkbox-button_disabled' : ''}${checked ? ' checkbox-button_checked' : ''}${clazz ? ` ${clazz}` : ''}`}
				htmlFor={id}
				tabIndex={0}
				onKeyUp={onKeyUp}
			>
				<input {...defaultCheckboxProps} />

				{textClazz ? <span className={textClazz}>{title}</span> : title}
				{children}
			</label>
		);
	}

	return (
		<label
			className={`checkbox${checked ? ' checkbox_checked' : ''}${disabled ? ' checkbox_disabled' : ''}${border ? `` : ` _no-border`}${important ? ` _important` : ''}${clazz ? ` ${clazz}` : ''}`}
			onKeyUp={onKeyUp}
			htmlFor={id}
		>
			<input
				{...defaultCheckboxProps}
				className={`${radio ? ' radio' : ''}`}
			/>
			{!!flag ? (
				<Icon
					icon
					type="flag"
					spritePath={`${flag.toUpperCase()}`}
				/>
			) : null}
			{icon && (
				<Icon
					icon
					size={iconSize}
					spritePath={`${icon}`}
					clazz={iconClazz}
				/>
			)}
			{textClazz ? (
				<span className={textClazz}>{title}</span>
			) : !border ? (
				<span>{title}</span>
			) : (
				title
			)}
			{children}
			{subTitle && typeof subTitle === 'string' ? (
				<span>{subTitle}</span>
			) : !!subTitle ? (
				subTitle
			) : null}
		</label>
	);
};

export default Checkbox;
